import React, { useState, useCallback } from "react";
import MaterialTable from '@material-table/core';
//import CustomTable from "./customTable";
// See https://material-table.com/#/docs/features/remote-data
import Box from '@mui/material/Box';
import { nlStatus } from "./helperFunctions";
import { render } from "@testing-library/react";

const ParticipantOverviewTable = ({ participants, currentState, nextPart }) => {
  const [selectedRowId, setSelectedRowId] = useState(0)

  const dutchStatus = useCallback((state) => {
    //const hlpState = nlStatus(state);
    //return `${hlpState} (${state})`;
    return nlStatus(state);
  });

  return (
    <Box>
      <MaterialTable
        // icons={tableIcons}
        localization={{
          pagination: {
            labelDisplayedRows: '{from}-{to} van {count}',
            labelRowsSelect: 'Rijen',
            labelRowsPerPage: 'Rijen per pagina:',
            firstAriaLabel: 'Eerste pagina',
            firstTooltip: 'Eerste pagina',
            previousAriaLabel: 'Vorige pagina',
            previousTooltip: 'Vorige pagina',
            nextAriaLabel: 'Volgende pagina',
            nextTooltip: 'Volgende pagina',
            lastAriaLabel: 'Laatste pagina',
            lastTooltip: 'Laatste pagina'
          },
          toolbar: {
            addRemoveColumns: 'Verwijder of voeg kolommen toe',
            nRowsSelected: '{0} rij(en) geselecteerd',
            showColumnsTitle: 'Toon kolommen',
            showColumnsAriaLabel: 'Toon kolommen',
            exportTitle: 'Export',
            exportAriaLabel: 'Export',
            exportName: 'Export als CSV',
            searchTooltip: 'Zoeken',
            searchPlaceholder: 'Zoeken'
            },
          header: {
              actions: 'Acties'
          },
          body: {
              emptyDataSourceMessage: 'Er zijn geen resultaten',
              filterRow: {
                  filterTooltip: 'Filter'
              }
          }
        }}
        options={{
          pageSize: 10,
          headerStyle: { position: 'sticky', top: 0, fontWeight: 'bold', color: "white", backgroundColor: '#019ce2' },
          rowStyle: (rowData, index) => ({
            backgroundColor:
            index % 2 === 0 ? "#D2EAEE" : "#E9F4F6",
          }),
          tableLayout: "fixed",
          padding: "dense"
        }}
        title="Deelnemers"
        columns={[
          {
            title: "ID",
            field: "id",
            hidden: true,
            width: 0
          },
          {
            title: "ParticipantID",
            field: "participantId",
            hidden: true,
            width: 0
          },
          {
            title: "Cap",
            field: "capnr",
            hidden: true,
            width: 0
          },
          {
            title: "Capnr",
            field: "displayCapnr",
            width: "7%",
            customSort: (a, b, type, direction) => { 
              return parseInt(a["displayCapnr"].replace(/\D/g, '')) - parseInt(b["displayCapnr"].replace(/\D/g, ''));
            }
          },
          {
            title: "Status",
            field: "state",
            width: "16%",
            render: rowData => dutchStatus(rowData.state)
          },
          {
            title: "Naam",
            field: "fullName",
            width: "19%"
          },
          {
            title: "Voornaam",
            field: "firstName",
            hidden: true,
            width: 0
          },
          {
            title: "Achternaam",
            field: "lastName",
            hidden: true,
            width: 0
          },
          {
            title: "Postcode",
            field: "zipcode",
            width: "10%"
          },
          {
            title: "Leeftijd",
            field: "age",
            width: "7%"
          },
          {
            title: "Afstand",
            field: "distance",
            width: "7%"
          },
          {
            title: "Team",
            field: "teamName",
            width: "15%"
          },
          {
            title: "Wave",
            field: "wave",
            width: "8%"
          },
          {
            title: "Telefoonnummer",
            field: "phone",
            width: "12%"
          }
        ]}
        data={participants}
        // onRowClick={(event, rowData) => {
        //   // if the rowData.tableDate.id could be used on condidtional render
        //   console.log(rowData);
        //   setSelectedRowId(rowData.tableData.id);
        // }}
      />

    </Box>
  );
}

export default ParticipantOverviewTable;
